import {FetchService} from "dc-services/fetch.service";

export async function replaceItemno() {
    let response;
    try {
        response = await FetchService.get('/em/itemReference/getAllItemNosForCustomer/');
    } catch {
        return;
    }
    if(response.success) {
        const refItems = document.querySelectorAll(".refItemno");
        for(const refItem of refItems) {
            const itemno = refItem.dataset.itemno;

            if (itemno && Object.hasOwn(response.data, itemno)) {
                const newItemNo = response.data[itemno];
                refItem.innerHTML = newItemNo;
            } else {
                refItem.innerHTML = itemno;
            }
            refItem.classList.remove("loadSkeleton");
        }
    }
}

export async function getReplacebleItemNo() {
    let response;
    try {
        response = await FetchService.get('/em/itemReference/getAllItemNosForCustomer/');
    } catch {
        return null;
    }
    if(response.success) {
        return response.data;
    }

    return null;
}